import moment from 'moment'
import './device-status.scss'
import { Indicator } from './Indicator'

export const DeviceStatus = (props) => {
  const { device, restartedAt = false, ...otherProps } = props
  return (
    <div {...otherProps}>
      <div className="device-status">
        {
          restartedAt && <p
            className="text-right m-0 mr-2 p-0"
          >
            <small className="opacity-25"> Last restarted { moment(restartedAt).fromNow() }</small>
          </p>
        }
        <Indicator device={device} state={props?.state} />
      </div>
    </div>
  )
}
